import PERMISSIONS from '../enum';
const downloadAccess = {
  donwnload: [PERMISSIONS.DOWNLOAD.VIEW],
  view: [PERMISSIONS.DOWNLOAD.VIEW, PERMISSIONS.QUESTION.EXPORT],
  delete: [PERMISSIONS.DOWNLOAD.DELETE],
};

export default downloadAccess;
